module.exports = __webpack_public_path__ + "AvertaStd-ExtraBoldItalic.svg?019544f9a22c8d77b4138ae4cc2adb44";